let intervalId: ReturnType<typeof setInterval> | null = null;
let originalTitle = "";

const NOTIFICATION_TEXT = "New message!";
const TOGGLE_INTERVAL_MS = 1000;

const stop = () => {
  if (intervalId !== null) {
    clearInterval(intervalId);
    intervalId = null;
  }
  if (originalTitle) {
    document.title = originalTitle;
    originalTitle = "";
  }
};

const onVisible = () => {
  if (document.visibilityState === "visible") stop();
};

export const notifyNewMessage = (): void => {
  if (document.visibilityState === "visible") return;
  if (intervalId !== null) return;

  originalTitle = document.title;
  let showNotification = true;

  intervalId = setInterval(() => {
    document.title = showNotification ? NOTIFICATION_TEXT : originalTitle;
    showNotification = !showNotification;
  }, TOGGLE_INTERVAL_MS);

  document.addEventListener("visibilitychange", onVisible);
};

export const clearTitleNotification = (): void => {
  document.removeEventListener("visibilitychange", onVisible);
  stop();
};
